import type { BpsLogPoint } from "./types";

// realtime表示の右端時刻(endMs)を、データ末尾やフォールバックから安全に決定する。
export const getRealtimeAxisEndMs = (
  data: BpsLogPoint[],
  nowMs: number,
  fallbackLagMs: number,
  prevEndMs?: number | null,
): { endMs: number; usedData: boolean } => {
  const maxAllowedEndMs = Math.floor(nowMs / 1000) * 1000;
  const fallbackBaseMs = Math.max(0, nowMs - Math.max(0, fallbackLagMs));
  const fallbackEndMs = Math.floor(fallbackBaseMs / 1000) * 1000;

  if (Array.isArray(data) && data.length > 0) {
    for (let i = data.length - 1; i >= 0; i--) {
      const raw = data[i]?.timestamp;
      if (typeof raw !== "string") continue;
      const ms = new Date(raw).getTime();
      if (!Number.isFinite(ms)) continue;
      const endMs = Math.floor(ms / 1000) * 1000;
      return { endMs: Math.min(endMs, maxAllowedEndMs), usedData: true };
    }
  }

  if (typeof prevEndMs === "number" && Number.isFinite(prevEndMs)) {
    return { endMs: Math.min(prevEndMs, maxAllowedEndMs), usedData: false };
  }

  return { endMs: fallbackEndMs, usedData: false };
};
